module.exports = __webpack_public_path__ + "static/media/gitlab.4e2fdd96.png";